import { render } from "./AssigApp.vue?vue&type=template&id=7efb6ecd&scoped=true"
import script from "./AssigApp.vue?vue&type=script&lang=js"
export * from "./AssigApp.vue?vue&type=script&lang=js"

import "./AssigApp.vue?vue&type=style&index=0&id=7efb6ecd&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efb6ecd"]])

export default __exports__